import { render } from "./Index.vue?vue&type=template&id=0c4e1ada&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=0c4e1ada&scoped=true&lang=less"

import exportComponent from "D:\\workCode\\cbc\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4e1ada"]])

export default __exports__